import React from "react";
import {GoogleOAuthProvider} from "@react-oauth/google";

export const WrapperGoogleAuthProvider = ({enabled = false, children}) => {
    return (
        <>
            {enabled ? (
                <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_API_CLIENT_ID}>
                    {children}
                </GoogleOAuthProvider>
            ) : (
                <>{children}</>
            )}
        </>
    );
};
